<script>
export default {
  mounted() {
    this.$nextTick(() => {
      if(this.$store.state.page.isPreview) return;

      const src = window.ldsTestSrc ? 'https://test.cdn.lds.xyz/sdk/lds.js' : 'https://cdn.lds.xyz/sdk/1.4.1/lds.js';
      // Add Tommie SDK script
      const tommieScript = () => {
        let s = document.createElement('script');
        s.async = true;
        s.type = 'module';
        s.src = src;
        let x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      tommieScript();

      if(!this.$store.state.page.isLanding) return;

      window._lds = window._lds || [];
      this.$store.commit('page/increasePixelStep', {label: 'Start'});
    });
  },
};
</script>
